import React from 'react';
import './Sections.css';

const Introduction = () => {
  return (
    <div className="introduction-container">
      <div className="text-box">
        <div className="inner-box" dir="rtl">
          <h2>היי נעים להכיר!</h2>
          <p>אני עידן עמנואל זוהר, הטכנאי מחשבים שתמיד מגיע עם חיוך וסבלנות.</p>
          <p>אני מאמין שטכנולוגיה צריכה להיות נגישה ופשוטה לכולם, ולכן אני כאן לעזור לכם בכל בעיה טכנית - קטנה כגדולה.</p>
          <p>עם ניסיון רב בתחום, אני מספק שירותי תיקון, תחזוקה ושדרוג של מחשבים אישיים ועסקיים, תוך שימוש בחלקים איכותיים במחירים הוגנים והכל עם שירות אישי ולבבי.</p>
          <p>אני מתמחה בפתרון בעיות מורכבות ובניית פתרונות מותאמים אישית לכל לקוח.</p>
          <p>בין אם אתם זקוקים לתיקון מהיר או לייעוץ טכנולוגי מקיף, אני כאן כדי להפוך את הטכנולוגיה לחלק טבעי וחלק מחיי היומיום שלכם.</p>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
